import { useMemo } from 'react';
import { useServices, isPerUnit } from '../services/useServices';

// The services planned for ONE function, shown inside the Edit Function form:
// who caters it, how many plates at what rate, who manages it, what is paid.
// It is the ordinary Services module filtered to this function - no new tables,
// no second source of truth; saving here shows up on the Services page too.
export function useFunctionServices(event, functionId) {
  const svc = useServices(event);

  const rows = useMemo(
    () => svc.rows.filter(r => String(r.FunctionId || '') === String(functionId || '')),
    [svc.rows, functionId]
  );

  const totals = useMemo(() => rows.reduce((acc, r) => ({
    total: acc.total + Number(r.TotalAmount || 0),
    advance: acc.advance + Number(r.AdvancePaid || 0),
    balance: acc.balance + Number(r.BalanceAmount || 0),
    units: acc.units + (isPerUnit(r.RateType) ? Number(r.ConfirmedCount || 0) : 0),
  }), { total: 0, advance: 0, balance: 0, units: 0 }), [rows]);

  // "+ Catering" / "+ Event Management" open the same form with the type, the
  // date and the slot already filled from the function being edited.
  const addFor = (typeName, fn) => {
    const type = svc.types.find(t => String(t.ServiceTypeName).toLowerCase() === String(typeName).toLowerCase());
    svc.openAdd({
      FunctionId: functionId ? String(functionId) : '',
      ServiceTypeId: type ? String(type.ServiceTypeId) : '',
      ServiceType: type?.ServiceTypeName || '',
      RateType: type?.RateType || 'Fixed',
      ServiceDate: String(fn?.FunctionDate || '').slice(0, 10) || undefined,
      StartTime: fn?.StartTime || '',
      EndTime: fn?.EndTime || '',
    });
  };

  const hasType = (name) => rows.some(r => String(r.ServiceType).toLowerCase() === String(name).toLowerCase());

  return { svc, rows, totals, addFor, hasType };
}
